<template lang="pug">
 #deletePassword
  .text-center
    b-icon(icon="x-circle" style="width: 80px; height: 80px; margin-bottom: 20px;" variant="danger")
    h2 ¿Estás Seguro?
    p Seguro que desea eliminar la contraseña
  .modal-footer
    b-button(@click="hideModal", variant="outline-muted") Cancelar
    b-button(@click="confirmDelete" variant="danger") Eliminar
</template>
<script>
import { mapActions } from 'vuex'
export default {
  props: ["selected", "hideModal", "makeToast"],
  data() {
    return{

    }
  },
  methods: {
    ...mapActions(['deletePassword']),
    async confirmDelete() {
      const response = await this.deletePassword(this.selected.id);
      if (response.status === 200) {
        this.$root.$bvToast.toast('La contraseña ha sido eliminada correctamente', {
            title: 'Exito!',
            variant: 'success'
          })
        this.hideModal()
      } else {
        this.$root.$bvToast.toast('Ocurrió un error', {
            title: 'Oops!',
            variant: 'danger'
          })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
#deletePassword {
  .modal-footer {
    padding: 0;
  }  
}
</style>